import { DefaultService } from '@/services/DefaultService';

export default class ProAssRotaContratoLpsService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    getAllByRota(id) {
        return this._http
            .get(`${this._env}/promotor/ass-rota-contrato-lps/by-rota/${id}.json`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    save(proAssRotaContratoLpsList, idrota) {
        return this._http
            .post(
                `${this._env}/promotor/ass-rota-contrato-lps/${idrota}`,
                proAssRotaContratoLpsList,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
